"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../basics/Icon"));
var typography_1 = require("../../typography");
var styles_1 = require("./styles");
var VS_1 = {
    '1': { small: 4, medium: 6, large: 8 },
    '2': { small: 4, medium: 4, large: 4 },
};
var LABEL = {
    '1': '1',
    '2': '2',
};
var ICON_SIZE = {
    '1': {
        small: 24,
        medium: 24,
        large: 24,
    },
    '2': {
        small: 20,
        medium: 20,
        large: 20,
    },
};
var Aside = function (_a) {
    var _b = _a.initialOpen, initialOpen = _b === void 0 ? false : _b, label = _a.label, _c = _a.color, color = _c === void 0 ? 'GREY_70' : _c, _d = _a.hoverColor, hoverColor = _d === void 0 ? 'GREY_90' : _d, backgroundColor = _a.backgroundColor, children = _a.children, _e = _a.level, level = _e === void 0 ? '1' : _e, commonProps = __rest(_a, ["initialOpen", "label", "color", "hoverColor", "backgroundColor", "children", "level"]);
    var _f = __read(react_1.default.useState(initialOpen), 2), open = _f[0], setOpen = _f[1];
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "AsideCollapsible" }, commonProps, { "$backgroundColor": backgroundColor, amount: VS_1[level] }),
        react_1.default.createElement(styles_1.Header, { onClick: function () { return setOpen(function (s) { return !s; }); }, color: color, hoverColor: hoverColor },
            react_1.default.createElement(typography_1.Label, { level: LABEL[level], color: "currentColor" }, label),
            react_1.default.createElement(Icon_1.default
            // color={labelColor === 'currentColor' ? undefined : labelColor}
            , { 
                // color={labelColor === 'currentColor' ? undefined : labelColor}
                name: open ? 'close' : 'plus', size: ICON_SIZE[level] })),
        open && react_1.default.createElement("div", null, children)));
};
exports.default = Aside;
